import { render, staticRenderFns } from "./Sortable.vue?vue&type=template&id=3bab5f3c&scoped=true&"
import script from "./Sortable.vue?vue&type=script&lang=ts&"
export * from "./Sortable.vue?vue&type=script&lang=ts&"
import style0 from "./Sortable.vue?vue&type=style&index=0&id=3bab5f3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bab5f3c",
  null
  
)

export default component.exports